import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import GuestList from "./GuestList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const GuestView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Guest | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Guests" breadcrumbItem="Manage Guests" />
          <GuestList />
        </Container>
      </div>
    </React.Fragment>
  )
}

GuestView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(GuestView)
